import {getMandarkURL, getOrigin} from '@albert-io/environment';

import {storePostLoginRedirect} from 'lib/postLoginRedirect';

export const GOOGLE_CLASSROOM_ASSIGNMENTS_FLAG = 'google_classroom_assignments';

/**
 * Sends the teacher through the backend's Google consent flow for the Classroom scopes
 * (`classroom=true`); `SocialLanding` returns them to the current page afterwards, whether
 * the connect succeeded or Google reported an error.
 */
export function startGoogleClassroomConsent(): void {
  storePostLoginRedirect(`${window.location.pathname}${window.location.search}`);
  window.location.assign(
    getMandarkURL(
      `/auth/google?${new URLSearchParams({classroom: 'true', redirect_host: getOrigin()})}`
    )
  );
}
